import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import Print from './print'

// import jquery from "jquery";
// Vue.prototype.$ = jquery;
// 导入全局样式表
import './assets/css/global.css'
import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'

import moment from 'moment'
import elDragDialog from '@/directive/el-drag-dialog'
import { Row, Col } from 'element-ui'
import {resetForm} from "./picth";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 富文本组件
import Editor from "@/components/Editor"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
//axios
import axios from "axios"
Vue.prototype.$axios = axios;
// //配置请求的根路径
// axios.defaults.baseUEL = 'http://192.168.29.214:80/'
axios.interceptors.request.use(config => {
  config.headers.Authorization = window.localStorage.getItem('token')
  return config
})
// 全局引入global
Vue.component('Editor', Editor)
Vue.component('ImagePreview', ImagePreview)

import global from "@/global/global.js"
Vue.prototype.global = global
Vue.prototype.$moment = moment
Vue.config.productionTip = false
// Vue.use(ElementUI,{ locale })
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(elDragDialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(Print) // 注册
Vue.prototype.resetForm = resetForm
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true, // 启用 inline 模式
    'button': true, // 显示右上角关闭按钮
    'navbar': true, // 显示缩略图导航
    'title': true, // 显示当前图片的标题
    'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    'rotatable': true, // 图片是否可旋转
    'scalable': true, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    'fullscreen': true, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
    'url': 'data-source' // 设置大图片的 url
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js